/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const DeleteMonitoringIntegrationHeaders = zod.object({
  'x-csrf-token': zod.string(),
  'Idempotency-Key': zod.string(),
});

export type DeleteMonitoringIntegrationHeaders = zod.input<
  typeof DeleteMonitoringIntegrationHeaders
>;
export type DeleteMonitoringIntegrationHeadersOutput = zod.output<
  typeof DeleteMonitoringIntegrationHeaders
>;
